(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rt-header"]) return;
  try {
    
  /*
   * Registered as `sticky-header` deliberately — Dawn's cart-notification.js,
   * media-gallery.js and quick-order-list.js all query that tag name and
   * depend on this interface:
   *   - reveal()                          cart-notification.js
   *   - 'preventHeaderReveal' event       media-gallery.js
   *   - offsetHeight + data-sticky-type   quick-order-list.js
   *   - --header-height custom property   Dawn CSS
   * Dawn's own StickyHeader lives inside header.liquid, which no longer
   * renders, so there is no double registration.
   */
  class RtStickyHeader extends HTMLElement {
    connectedCallback() {
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.preventHide = false;
      this.headerBounds = {};
      this.predictiveSearch = this.querySelector('predictive-search');

      this.setHeaderHeight();
      this.resizeObserver = new ResizeObserver(() => this.setHeaderHeight());
      this.resizeObserver.observe(this);

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries, obs) => {
        this.headerBounds = entries[0].intersectionRect;
        obs.disconnect();
      });
      observer.observe(this);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      // Never retract while the mobile drawer is open.
      if (document.body.classList.contains('rt-drawer-open')) return;

      this.classList.toggle('rt-header-wrapper--scrolled', scrollTop > 40);

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop) {
        if (this.preventReveal) {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        } else {
          requestAnimationFrame(this.reveal.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.classList.add('rt-header-wrapper--hidden');
      this.closeSearchModal();
    }

    reveal() {
      this.classList.remove('rt-header-wrapper--hidden');
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', RtStickyHeader);
  }

  /*
   * Mobile drawer.
   *
   * The <details> element supplies open/close state and native keyboard
   * behaviour. This adds what a conventional drawer needs on top: scroll
   * lock, Escape, close via backdrop or button, aria-expanded on the
   * trigger, a focus trap while open, and focus returned to the trigger
   * on close.
   */
  (function () {
    const drawer = document.getElementById('RtMenuDrawer');
    if (!drawer || drawer.dataset.rtBound === 'true') return;
    drawer.dataset.rtBound = 'true';

    const trigger = drawer.querySelector('summary.rt-drawer-trigger');
    const panel = drawer.querySelector('.rt-drawer');
    const FOCUSABLE =
      'a[href], button:not([disabled]), summary, input, select, textarea, [tabindex]:not([tabindex="-1"])';

    const close = () => {
      drawer.open = false;
    };

    drawer.addEventListener('toggle', () => {
      const open = drawer.open;
      document.body.classList.toggle('rt-drawer-open', open);
      if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');

      if (open) {
        // Focus the panel so screen readers land inside the dialog.
        const first = panel.querySelector(FOCUSABLE);
        if (first) first.focus({ preventScroll: true });
      } else if (trigger) {
        trigger.focus({ preventScroll: true });
      }
    });

    drawer.querySelectorAll('[data-rt-drawer-close]').forEach((el) => {
      el.addEventListener('click', (event) => {
        event.preventDefault();
        close();
      });
    });

    // Navigating should close it, so returning via back button is not stuck.
    panel.addEventListener('click', (event) => {
      if (event.target.closest('a[href]')) close();
    });

    document.addEventListener('keydown', (event) => {
      if (!drawer.open) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        return;
      }

      if (event.key !== 'Tab') return;

      // Trap focus inside the panel while it is modal.
      const items = Array.from(panel.querySelectorAll(FOCUSABLE)).filter(
        (el) => el.offsetParent !== null
      );
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      } else if (!panel.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    });

    window.matchMedia('(min-width: 990px)').addEventListener('change', (event) => {
      if (event.matches && drawer.open) close();
    });
  })();

  /*
   * Desktop dropdowns: only one open at a time, close on outside click and
   * on Escape. <details> handles the rest natively.
   */
  (function () {
    const menus = Array.from(document.querySelectorAll('[data-rt-nav-disclosure]'));
    if (!menus.length) return;

    menus.forEach((d) => {
      d.addEventListener('toggle', () => {
        if (!d.open) return;
        menus.forEach((other) => {
          if (other !== d) other.open = false;
        });
      });
    });

    document.addEventListener('click', (event) => {
      menus.forEach((d) => {
        if (d.open && !d.contains(event.target)) d.open = false;
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      menus.forEach((d) => {
        if (d.open) {
          d.open = false;
          const s = d.querySelector('summary');
          if (s) s.focus();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
